export const EMAIL_HANDOFF_FORM_TYPE = 'emailhandoff';
export const EMAIL_HANDOFF_COOKIE = 'sxm_email_handoff';
export const MAX_AGE_EMAIL_HANDOFF_COOKIE = 60;
